import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { INommable } from '../nommable.interface';
import { UserEvent } from './user-event.model';

export class InfoRondePonctuelleEvent extends UserEvent {
  public static NAME = 'INFO_RONDE_PONCTUELLE';

  constructor(
    public texte: string | undefined,
    public photos: string[],
    instant?: dayjs.Dayjs,
    coordinates?: Coordinates,
    public siteId?: string,
    public tourneeId?: string,
    public site?: INommable
  ) {
    super(InfoRondePonctuelleEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: InfoRondePonctuelleEvent): InfoRondePonctuelleEvent {
    return new InfoRondePonctuelleEvent(obj.texte, obj.photos, obj.instant, obj.coordinates, obj.siteId, obj.tourneeId, obj.site);
  }
}
